// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"ee7a2a38","298":"4dd4db7c","639":"1d8460c7","652":"1363bcde","678":"69b3326d","690":"71755251","822":"3f3a9e50","880":"aa1371ce","883":"1e513948","991":"daeceafd"}[chunkId] + ".chunk.js";
};